export const selectGuestId = ({user}) => user?.guestId;
export const selectUserId = ({user}) => user?.userId;
